(function(){
    var $script = document.currentScript;

    var StickyATC = (function($script){
        var observer, $bar, productJSON;
        var $section = $script.closest('.shopify-section');
        var $mainBtn = $section.querySelector('form button.add-to-cart');

        function addStyles() {
            var style = document.createElement('style');

            style.textContent = `
                #preview-bar-iframe {
                    bottom: 100px !important;
                }

                .stick-atc-bar {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right:0;
                    background-color: white;
                    padding: 10px 0;
                    z-index: 9;
                    box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
                    transform: translateY(105%);
                    transition: ease-in-out all 300ms;
                }

                .stick-atc-bar.open {
                    transform: translateY(0);
                }

                .sticky-atc-wrapper {
                    display: flex;
                }

                .sticky-atc-product__wrapper {
                    display: none;
                    flex-grow: 1;
                    align-items: center;
                    justify-content: flex-start;
                    padding-right: 45px;
                }

                .sticky-product__content {
                    padding-left: 15px;
                    display: flex;
                    flex-grow: 1;
                    align-items: center;
                    justify-content: space-between;
                }

                .sticky-variant-details {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    text-align: right;
                    justify-content: center;
                }
                
                span[data-sticky-variant-price] {
                    font-size: 1.1em;
                }

                span[data-sticky-variant-choice] {
                    letter-spacing: 0;
                }

                .sticky-product__content .trustpilot-wrapper p {
                    margin-bottom: 0;
                }

                .sticky-atc-img img {
                    max-height: 75px;
                }

                @media (min-width: 768px) {
                    .sticky-atc-product__wrapper {
                        display: flex;
                    }
                }


                .sticky-atc-form__wrapper {
                    display: flex;
                    align-items: center;
                    width: 100%;
                }

                
                @media (min-width: 768px) {
                    .sticky-atc-form__wrapper {
                        width: calc(40% - 57px);
                    }
                }
            `;

            document.head.appendChild(style);
        }

        function cloneEl($el, html) {
            if(html) {
              var $temp = document.createElement('div');
              $temp.appendChild($el.cloneNode(true));

              return $temp.innerHTML;
            }
            return $el.cloneNode(true);
        }

        function getTrustPilot() {
            return document.querySelector('.trustpilot-wrapper') ? cloneEl(document.querySelector('.trustpilot-wrapper'), true) : '';
        }

        function getCurrentVariant() {
            var $select = document.querySelector('select[name="id"]')

            return productJSON.variants.find(function(variant) {
                return variant.id == $select.value;
            })
        }

        function updateVariantDetails() {
            var variant = getCurrentVariant();
            var $price = $bar.querySelector('span[data-sticky-variant-price]');
            var $choice = $bar.querySelector('span[data-sticky-variant-choice]');

            var variantChoices = [...document.querySelectorAll('.variant-input-wrap select')].map(function($select) {
                return $select.value;
            }).join(' ');

            $price.innerHTML = `
            ${
                variant.compare_at_price > variant.price ?
                ` 
                <span class="product__price on-sale">${theme.Currency.formatMoney(variant.price)}</span>
                <span class="product__price product__price--compare">${theme.Currency.formatMoney(variant.compare_at_price)}</span>
                `
                :
                `<span class="product__price">${theme.Currency.formatMoney(variant.price)}</span>`
            }
            `;
            $choice.textContent = 'Du har valgt: ' + variantChoices;

            console.log('Sticky update variant', variant, $price, $choice);
        }

        function createBar() {
            $bar = document.createElement('div');
            $bar.classList.add('stick-atc-bar');

            $bar.innerHTML = `
                <div class="sticky-atc-wrapper page-width">
                    <div class="sticky-atc-product__wrapper">
                        <div class="sticky-atc-img">
                            <img src="${window.Images.getSizedImageUrl(productJSON.images[0], 'x85')}" />
                        </div>
                        <div class="sticky-product__content">
                            <div class="sticky-product-details">
                                <h3>${productJSON.title}</h3>
                                ${getTrustPilot()}
                            </div>
                            <div class="sticky-variant-details">
                              <span data-sticky-variant-price></span>
                              <span data-sticky-variant-choice></span>
                            </div>
                        </div>
                    </div>
                    <div class="sticky-atc-form__wrapper">
                        ${cloneEl($mainBtn, true)}
                    </div>
                </div>
            `;
            console.log('Create Bar');


            updateVariantDetails()
            document.addEventListener('variant:change',  updateVariantDetails)
            $bar.querySelector('.add-to-cart').addEventListener('click', function(event) {
                $mainBtn.click();
            })

            document.body.appendChild($bar);
        }

        function createObserver({options, target, callback}) {
            var options = {
                rootMargin: '0px',
                threshold: 1.0,
                ...options,
            }
              
            var observer = new IntersectionObserver(callback, options);

            observer.observe(target);

            return observer;
        }

        function toggleBar(show) {
            console.log('Show!', show);

            if(show) {
                $bar.classList.add('open');
            } else{
                $bar.classList.remove('open');
            }
        }

        function primaryObserverCallback(entries, observer) {
            var entry = entries[0];
            var isIntersecting = entry.isIntersecting;

            toggleBar(!isIntersecting);
            console.log('Sticky Primary Callback', {
                entries,
                isIntersecting,
                observer
            })
        }

        function fetchFreshProduct() {
            var handle = location.pathname.split('/').reverse()[0];
            var url = window.Shopify.locale == 'da' ? `/products/${handle}.js` : `/${window.Shopify.locale}/products/${handle}.js`

            return fetch(url).then(function(res){ return res.json() });
        }

        async function init() {

            productJSON = await fetchFreshProduct();

            // Attach $bar to document & add corresponding styles.
            createBar();
            addStyles();

            // Create observer to interact with $bar.
            observer = createObserver({
                callback: primaryObserverCallback,
                target: $mainBtn
            });

            console.log('Sticky Init', {productJSON, $section, $script});            
        }

        return  {
            init,
        }
        
    })($script);

    StickyATC.init();

    console.log('Sticky ATC', $script);
})();